var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLinesImageAdaptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 609,
    viewBox: "0 0 613 609",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.477 278.609C173.243 324.406 183.922 396.152 266.286 436.271",
    stroke: "url(#paint0_linear_1959_15069)",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5 294.742C580.153 335.351 570.663 398.968 497.469 434.542",
    stroke: "url(#paint1_linear_1959_15069)",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 107.797H73.5119L97.933 129.547H158.422C200.843 3.97327 466.724 -87.6503 594.996 146.422",
    stroke: "url(#paint2_linear_1959_15069)",
    strokeOpacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.398 399.509C474.864 399.509 549.012 325.361 549.012 233.895C549.012 142.429 474.864 68.2812 383.398 68.2812",
    stroke: "url(#paint3_linear_1959_15069)",
    strokeOpacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.169 287.14C184.248 157.139 277.946 64.4776 373.719 68.2809",
    stroke: "url(#paint4_linear_1959_15069)",
    strokeOpacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.862,
    cy: 287.139,
    r: 5.18623,
    fill: "#61DCF6",
    fillOpacity: 0.23
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.512,
    cy: 287.489,
    r: 3.45749,
    fill: "#61DCF6",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("path", {
    d: "M611.034 489.777H442.309",
    stroke: "#56919D",
    strokeOpacity: 0.57
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 442.573,
    cy: 489.655,
    r: 5.18623,
    fill: "#61DCF6",
    fillOpacity: 0.56
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 443.536,
    cy: 489.719,
    r: 3.45749,
    fill: "#61DCF6",
    fillOpacity: 0.71
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 95.6133,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 95.6133,
    r: 1.5,
    fill: "white",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 97.1133,
    r: 3,
    fill: "white",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 97.1133,
    r: 1,
    fill: "white",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 15.1133,
    r: 3,
    fill: "white",
    fillOpacity: 0.64
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 15.1133,
    r: 2,
    fill: "white",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 544.5,
    cy: 355.613,
    r: 2.5,
    fill: "white",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 544.5,
    cy: 355.613,
    r: 1.5,
    fill: "white",
    fillOpacity: 0.52
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 357.545,
    cy: 430.659,
    r: 2.54531,
    fill: "#D9D9D9",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 357.542,
    cy: 430.66,
    r: 1.37055,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_1959_15069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538 603.113C538 604.218 537.105 605.113 536 605.113C534.895 605.113 534 604.218 534 603.113C534 602.009 534.895 601.113 536 601.113C537.105 601.113 538 602.009 538 603.113Z",
    fill: "white",
    fillOpacity: 0.63
  })), /*#__PURE__*/React.createElement("path", {
    d: "M537 603.113C537 603.666 536.552 604.113 536 604.113C535.448 604.113 535 603.666 535 603.113C535 602.561 535.448 602.113 536 602.113C536.552 602.113 537 602.561 537 603.113Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.359 513.534H247.094L266.236 492.789H307.149",
    stroke: "url(#paint5_linear_1959_15069)",
    strokeOpacity: 0.29
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1959_15069",
    x: 0,
    y: 0.199219,
    width: 612.035,
    height: 605.914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1959_15069",
    x: 202.876,
    y: 270.153,
    width: 33.9711,
    height: 33.9711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.9,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1959_15069",
    x: 211.455,
    y: 279.431,
    width: 16.1141,
    height: 16.1141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1959_15069",
    x: 425.587,
    y: 472.669,
    width: 33.9711,
    height: 33.9711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.9,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1959_15069",
    x: 435.478,
    y: 481.662,
    width: 16.1141,
    height: 16.1141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1959_15069",
    x: 221.7,
    y: 89.8133,
    width: 11.6,
    height: 11.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1959_15069",
    x: 225.3,
    y: 93.4133,
    width: 4.4,
    height: 4.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1959_15069",
    x: 523.6,
    y: 90.7133,
    width: 12.8,
    height: 12.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1959_15069",
    x: 349.6,
    y: 6.71328,
    width: 16.8,
    height: 16.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.7,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1959_15069",
    x: 537.7,
    y: 348.813,
    width: 13.6,
    height: 13.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1959_15069",
    x: 541.5,
    y: 352.613,
    width: 6,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1959_15069",
    x: 348.9,
    y: 422.013,
    width: 17.2898,
    height: 17.2898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.05,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1959_15069",
    x: 354.172,
    y: 427.289,
    width: 6.74219,
    height: 6.74219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1959_15069",
    x: 530.2,
    y: 597.313,
    width: 11.6,
    height: 11.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9,
    result: "effect1_foregroundBlur_1959_15069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1959_15069",
    x1: 169.498,
    y1: 278.785,
    x2: 249.251,
    y2: 436.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60D7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377B89",
    stopOpacity: 0.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1959_15069",
    x1: 583.481,
    y1: 294.898,
    x2: 512.855,
    y2: 434.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60D7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377B89",
    stopOpacity: 0.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1959_15069",
    x1: 1,
    y1: 74.0604,
    x2: 594.996,
    y2: 74.0604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DCF6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188213,
    stopColor: "#61DCF6",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444357,
    stopColor: "#42A5B9",
    stopOpacity: 0.549929
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28798A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1959_15069",
    x1: 415.602,
    y1: 81.451,
    x2: 416.59,
    y2: 399.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D7281",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387D8C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1959_15069",
    x1: 366.804,
    y1: 68.2824,
    x2: 218.823,
    y2: 286.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FC8DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FC8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1959_15069",
    x1: 127.359,
    y1: 503.162,
    x2: 307.149,
    y2: 503.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DDF7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61DCF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLinesImageAdaptive);
export default __webpack_public_path__ + "static/media/MainLinesImageAdaptive.5ccec89806b784eb41cdf26ebd33accd.svg";
export { ForwardRef as ReactComponent };